export class CustomerSegmentPreviewListItemDataObject {
	/**
	 * @param {string} id - Customer's DB ID.
	 * @param {string} crmId - Customer's external CRM ID.
	 * @param {string} firstName - Customer's first name.
	 * @param {string} lastName - Customer's last name.
	 * @param {string} phone - Customer's mobile phone number.
	 * @param {string} email - Customer's email address.
	 * @param {Date} dateOfBirth - Customer's date of birth.
	 */
	constructor(id, crmId, firstName, lastName, phone, email, dateOfBirth) {
		this.id = id;
		this.crmId = crmId;
		this.firstName = firstName;
		this.lastName = lastName;
		this.phone = phone;
		this.email = email;
		this.dateOfBirth = dateOfBirth;
	}
}